//@flow
export const anamneseConstants = {
    CHANGE_EDITING: "CHANGE_EDITING"
};
